import "./Nav.css";
import React, { useEffect, useState } from "react";

function Nav() {
  return (
    <div className="nav">
      <img
        className="nav__logo"
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1597px-Netflix_2015_logo.svg.png"
        alt="Netflix Logo"
      />

      <img
        className="nav__avatar"
        src="https://i.pinimg.com/originals/eb/05/eb/eb05eb6fb0880b5c811669b60b0278bb.png"
        alt="Netflix Logo"
      />
    </div>
  );
}

export default Nav;
